import instance from './instance';

export const fetchUserSuggestions = () => instance.get('/user_suggestions');

export const updateUserSuggestion = ({ slug, data }) => instance.put(`/user_suggestions/${slug}`, data);
